import { Type } from "@angular/core";
import { BudgetedPositionsChartComponent, HumanResourcesEmployeeTaskCompletionChartComponent, OpenEnrollmentChartComponent, OvertimeUsageChartComponent, SickLeaveChartComponent, TurnoverChartComponent } from './components';

export * from './provider';
export * from "./components";
export * from "./services";
export { EmployeeProfileModel } from "./interfaces";

export const PR_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "Payroll.OpenEnrollmentChart": OpenEnrollmentChartComponent,
    "Payroll.BudgetedPositionsChart": BudgetedPositionsChartComponent,
    "HumanResources.EmployeeTaskCompletionChart": HumanResourcesEmployeeTaskCompletionChartComponent,
    "Payroll.OvertimeUsageChart": OvertimeUsageChartComponent,
    "Payroll.SickLeaveChart": SickLeaveChartComponent,
    "Payroll.TurnoverChart": TurnoverChartComponent
};
